<template>
  <div class="jobs-search-main">
    <PcNavbar/>
    <div class="search-title">
      <div class="search-main">
        <Filtrate
          :isCompanySearch="true"
          :queryData="queryData"
          :showIntention="false"
          @reset="filtrateReset"
          @showMoreCity="showCity = true"
          @select="filtrateSelect"/>
      </div>
    </div>
    <div class="content">
      <div class="left-model">
        <div v-if="isShowLoading">
          <skeleton :options="{count: 6, moduleCount: 1}" v-for="item in 6" :key="item" style="margin-bottom: 16px;"/>
        </div>
        <template v-else>
          <search-company-card class="company" :data="company" v-if="company"/>
          <ItemList
            class="item"
            v-for="(item, index) in data"
            :key="index"
            :data="item"/>
          <div v-if="!data.length" style="background: #fff;margin-top: 0px;padding: 120px 0;">
            <img src="https://files.wondercv.com/no_content_search@2x.png" alt="" style="width: 50%;margin: auto;">
          </div>
          <page style="margin-top: 16px;" :total="total" :pageSize="size" :currentPage="this.queryData.page" @current-change="currentChange"/>
        </template>
      </div>
      <div class="right-model">
        <!-- <div class="jd" v-if="_t">
          <div class="jd-title">最近浏览职位</div>
        </div> -->
        <wx/>
        <div class="banner-carousel" v-if="banner.image">
          <img :src="banner.image" alt="" v-if="!banner.link">
          <a v-else :href="banner.link" target="_blank">
            <img :src="banner.image" alt="">
          </a>
        </div>
      </div>
    </div>

    <PcFooter/>
    <city
      :show="showCity"
      :queryData="queryData"
      @select="selectCity"
      @close="showCity = false;"/>
    <industry
      :show="showIndustry"
      :queryData="queryData"
      @select="selectIndustry"
      @close="showIndustry = false;"/>
  </div>
</template>
<script>
import PcNavbar from '@/components/base/navbar';
import PcFooter from '@/components/base/pcFooter';
import ItemList from './components/itemList';
import Search from '@/components/search';
import Filtrate from './components/filtrate';
import Wx from '@/components/wxQrcode';
import City from './components/city';
import Industry from './components/industry';
import Page from '@/views/components/page';
import skeleton from '@/components/base/skeleton';

import conditions from '@/assets/json/conditions'

import { get_tUser, dealSignatrue, routerTo, auth } from '@/assets/js/util';
import api from '@/api';
import { mapState, mapActions } from 'vuex'
import * as staticApi from "../../api/list/static";
import SearchCompanyCard from "./components/searchCompanyCard"
const size = 10;
export default {
  name: 'companyJobsSearch',
  components: {
    PcNavbar,
    PcFooter,
    ItemList,
    Search,
    Filtrate,
    Wx,
    City,
    Industry,
    Page,
    skeleton,
    SearchCompanyCard
  },
  data() {
    return {
      _t: '',
      size,
      constData: {},
      queryData: {
        token :this.$route.params.token,
        size,
        page: this.$route.query.page || 1,
        city_names: this.$route.query.city_names,
        company_industry: this.$route.query.company_industry,
        company_scale: this.$route.query.company_scale,
        company_nature: this.$route.query.company_nature,
        job_nature: this.$route.query.job_nature,
        degree_name: this.$route.query.degree_name,
        salary: this.$route.query.salary,
        experience: this.$route.query.experience,
        profession_level1: this.$route.query.profession_level1 && this.$route.query.profession_level1.split(',') || []
      },
      showCity: false, // 显示城市弹窗
      showIndustry: false, // 显示行业弹窗
      data: [],
      total: 0,
      isShowLoading: true,
      banner: {},
      company: null,//搜索的公司信息
    };
  },
  created() {
    // this.$store.dispatch('app/setNavbarAction', '热门职位');
    this._t = get_tUser().c_t || '';
    this.getList();
    this.getBanner();
  },
  computed: {
    ...mapState('cv', ['onlineCvData']),
    ...mapState('me', ['personInfo']),
  },
  methods: {
    ...mapActions('cv', ['getOnlineCvData']),
    async getList() {
      this.showCity = false; // 显示城市弹窗
      this.showIndustry = false; // 显示行业弹窗
      this.isShowLoading = true; //显示骨架图loading
      // if (!this.onlineCvData) await this.getOnlineCvData(this._t)
      let queryData = {
        ...this.queryData,
        cv_account_token: this._t,
        // cv_account_id: this.personInfo.id || '',
        // resume_token: this.onlineCvData.token || ''
      };
      for (let i in queryData) {
        if (queryData[i] === '不限' || queryData[i] === '全国') queryData[i] = '';
        if(Array.isArray(queryData[i]) && queryData[i].includes('不限')) queryData[i] = []
        queryData[i] = queryData[i] === undefined ?  "" : queryData[i]
      }
      // let res = await api.jobs.companyListUnlogin(queryData);

      // 把1年以内 改成 1年以下 搜索
      if (queryData.experience === '1年以内') {
        queryData.experience = '1年以下'
      }
      try {
          let res = await api.jobs.getCompanyJobs(queryData);
          if (res.code === 1000) {
            this.data = res.data.data.jobs || []
            this.total = res.data.data.total || 0
          }
        } catch (e) {
          console.log(e)
      }
      this.isShowLoading = false;
    },
    checkFill (data) {
      return !!(
        data.city_names ||
        data.company_industry ||
        data.company_nature ||
        data.company_scale ||
        data.degree_name ||
        data.experience ||
        data.job_nature ||
        data.keyword ||
        data.salary
      )
    },
    // 筛选
    filtrateReset() {
      this.queryData = {
        ...this.queryData,
        page: 1,
        size: 10,
        token: this.$route.query.token,
        city_names: '',
        company_industry: '',
        job_nature: '',
        company_scale: '',
        company_nature: '',
        salary: '',
        degree_name: '',
        experience: '',
        profession_level1: []
      };
      this.$forceUpdate();
      this.setUrlQuery(this.queryData);
    },
    filtrateSelect(data) {
      if(data.key !== "profession_level1") {
        this.queryData[data.key] = data.key === 'salary' ? data.data.code : data.data.name
      } else {
        this.queryData.profession_level1 = Array.isArray(this.queryData.profession_level1) ? this.queryData.profession_level1 : this.queryData.profession_level1.split(',');
        let index = this.queryData.profession_level1.findIndex(item => item == data.data.name);
        if(index > -1){
          this.queryData.profession_level1.splice(index, 1);
        }else {
          this.queryData.profession_level1.push(data.data.name)
        }
        if(data.data.name == '不限') this.queryData.profession_level1 = ['不限']
        if(data.data.name !== '不限' && this.queryData.profession_level1.indexOf('不限') > -1) {
          this.queryData.profession_level1 = this.queryData.profession_level1.filter(item => item != '不限')
        }
      }
      // console.log(data,'=>>>>');
      // console.log(this.queryData);
      this.$forceUpdate();
      this.setUrlQuery(this.queryData);
    },
    selectCity(data) {
      console.log(data);
      this.queryData = {
        ...this.queryData,
        city_names: data.city_name,
      };
      this.setUrlQuery(this.queryData);
    },
    selectIndustry(data) {
      this.queryData = {
        ...this.queryData,
        company_industry: data.name,
      };
      this.setUrlQuery(this.queryData);
    },
    currentChange(page) {
      // console.log(page);
      this.queryData.page = page
      this.setUrlQuery(this.queryData);
    },
    async setUrlQuery(data) {
      data = JSON.parse(JSON.stringify(data));
      delete data.parsed_query
      delete data.token
      // 去除空字符
      for (let i in data) {
        let isDeleted = !data[i]
          || i === 'size'
          || data[i] === '不限'
          || data[i] === '全国'
          || i === 'page_size'
          || (i === 'page' && data[i] === 1)
          || (Array.isArray(data[i]) && (data[i].length == 0 || (data[i].length == 1 && data[i].includes('不限'))))
        if (isDeleted) delete data[i];
      }
      // 拼接字符串
      let str = '?';
      for (let i in data) {
        str += `${i}=${data[i]}&`;
      }
      str = str.replace(/&$/gim, '');
      str = str === '?' ? '' : str;
      str = this.$route.path + str;
      // 设置url
      await window.history.pushState('', '', str);
      // if (!this.onlineCvData) await this.getOnlineCvData(this._t)
      await this.getList()
    },

    async getBanner() {
      // banner
      let res = await api.jobs.getBanner({position: '10'});
      if(res.data.length){
        this.banner = res.data[0] || {};
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.jobs-search-main {
  padding-top: 55px;
  .search-title {
    background: #fff;
    padding-top: 28px;
    .search-main {
      width: 1196px;
      margin: auto;
      .search {
        width: 900px;
        margin-left: 0;
      }
    }
    .city {
    width: 92px;
    height: 100%;
    text-align: center;
    font-size: 14px;
    color: #404040;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.active,
    &:hover {
      color: #FF6644;
    }
    .iconfont {
      margin-left: 4px;
    }
    &::after {
      content: "";
      display: block;
      width: 1px;
      height: 24px;
      background: #ECECEC;
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -12px;
    }
  }
  .industry {
    width: 104px;
    height: 100%;
    text-align: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #404040;
    &.active,
    &:hover {
      color: #FF6644;
    }
    &>div {
      max-width: 70px;
      flex: none;
    }
    .iconfont {
      margin-left: 4px;
    }
    &::after {
      content: "";
      display: block;
      width: 1px;
      height: 24px;
      background: #ECECEC;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -12px;
    }
  }
  }
  .content {
    width: 1196px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    padding-bottom: 65px;
    .left-model {
      width: 880px;
      .item {
        margin-bottom: 16px;
      }
    }
    .right-model {
      width: 300px;
      .jd {
        background: #fff;
        .jd-title {
          height: 38px;
          line-height: 38px;
          font-size: 14px;
          color: rgba(64, 64, 64, 1);
        }
      }
      .banner-carousel {
        width: 100%;
        margin-top: 24px;
        border-radius: 2px;
        overflow: hidden;
        img {
          width: 100%;
        }
    }
    }
  }
}
</style>
<style lang="scss">
.jobs-search-main {
  .search-title {
    .filtrate-main {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
